import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatCurrency } from './utils';

interface DetailSection10Props {
  submission: CreditSubmission;
}

export default function DetailSection10({ submission }: DetailSection10Props) {
  if (!submission.credit_history || submission.credit_history.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>10. Riwayat Kredit</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {submission.credit_history.map((history: any, index: number) => (
            <div key={index} className="border rounded-lg p-4 bg-gray-50">
              <div className="grid md:grid-cols-2 gap-4">
                {Object.entries(history).map(([key, value]: [string, any]) => {
                  // Format currency for amount fields
                  const isAmountField =
                    key.includes('amount') ||
                    key.includes('plafon') ||
                    key.includes('outstanding') ||
                    key.includes('limit');
                  const displayValue =
                    isAmountField && typeof value === 'number'
                      ? formatCurrency(value)
                      : typeof value === 'object' && value !== null
                        ? JSON.stringify(value)
                        : String(value || '-');

                  return (
                    <div key={key}>
                      <label className="text-xs text-gray-600 capitalize">
                        {key.replace(/_/g, ' ')}
                      </label>
                      <p className="font-medium mt-1">{displayValue}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
